import React from 'react'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import { CDN_URL } from '../../../../shared/constants/cdn'
import styled from 'styled-components'

const Avatar = styled.img`
  border-radius: 50%;
  height: 50px;
  object-fit: cover;
  width: 50px;
`
const UserCard = (flops) => {
  const { image, name, title } = flops

  return (
    <Grid container alignItems="center" justify="flex-start">
      <Grid item>
        <Avatar src={CDN_URL + image} />
      </Grid>
      <Grid item>
        <Box flexDirection="column" ml={2}>
          <Box>{name}</Box>
          {/* TODO: remove font-size property after designsers provide global style */}
          <Box fontSize={12}>{title}</Box>
        </Box>
      </Grid>
    </Grid>
  )
}

export default UserCard
